import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

export default [
  {
    path: 'connect/get-started',
    name: 'getStarted',
    component: () => import(/* webpackChunkName: "connect-section" */ '@/components/pages/connect/GetStartedWizard.vue'),
    meta: { title: 'Get started' },
  },
  {
    path: 'connect/get-started/integration/:integration',
    name: 'getStartedIntegration',
    component: () => import(/* webpackChunkName: "connect-section" */ '@/components/pages/connect/GetStartedIntegration.vue'),
    meta: { title: 'Get started' },
  },
  {
    path: 'connect/get-started/test/:integration',
    name: 'getStartedTest',
    component: () => import(/* webpackChunkName: "connect-section" */ '@/components/pages/connect/GetStartedTest.vue'),
    meta: { title: 'Test your data' },
  },
  {
    path: 'connect/manage',
    name: 'connections',
    component: () => import(/* webpackChunkName: "connect-section" */ '@/components/pages/connect/ActiveConnections.vue'),
    meta: { title: 'Manage Connections' },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'Connect',
  },
}));
